import axios from 'axios';
import { getAuthenticationInfo } from '../common/auth';

const configReader = require('../config');

/**
 * Downloads the PLAY players CSV by making an authenticated GET and triggering
 * a save-as via a Blob URL (anchor downloads can't send Authorization headers).
 */
export async function downloadCsv() {
  const { Token } = getAuthenticationInfo() ?? {};
  const { wsApiUrl } = configReader.get();

  const response = await axios.get(`${wsApiUrl}/admin/play/report.csv`, {
    headers: {
      Accept: 'text/csv',
      ...(Token ? { Authorization: `Bearer ${Token}` } : {}),
    },
    responseType: 'blob',
  });

  const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;

  // Try to use the server-provided filename
  const disposition = response.headers['content-disposition'] || '';
  const match = disposition.match(/filename="?([^";]+)"?/i);
  link.download = match ? match[1] : `play-players-${Date.now()}.csv`;

  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
